// locked_x and related constants.
export const LOCKED_RATE = 'Locked Rate';
export const LOCKED_PRODUCT = 'Locked Product';

// buy_side_x and related constants.
export const BUY_SIDE_PRODUCT = 'Buy Side Product';
export const BUY_SIDE_RATE = 'Buy Side Rate';

export const EntityTypes = {
  AUDIENCE: 'audience',
  CUSTOM_VALUE: 'customvalue',
};

// used to display as user when system auto publishes or reprices
export const POLLY_SYSTEM_USER = 'Polly System';

// used for stupidly large product responses
export const PRODUCT_PAGE_SIZE = 15000;
